import React, { Component } from "react";
import "./style.scss";
// import { Appointments, TreatmentHistory, PurchaseHistory, PersonalDetails, Favourites } from './Details'
import classnames from "classnames";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { FormGroup, Label, Input } from "reactstrap";
import { NormalInput, NormalButton, TableWrapper } from "component/common";
import {
  getCommonApi,
  updateForm,
  commonCreateApi,
  commonDeleteApi,
  commonPatchApi,
} from "redux/actions/common";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { PDFViewer, PDFDownloadLink, BlobProvider } from "@react-pdf/renderer";
import Invoice from "component/Admin/Report/Account/Invoice";
import { withTranslation } from "react-i18next";
import { history } from "helpers";
export class VoucherTabClass extends Component {
  state = {
    activeTab: "",
    isOpenTreatmentDone: false,
    isActiveTab: "detail",
    headerDetails: [
      {
        label: "Date",
        width: "80px",
        divClass: "d-flex justify-content-center ",
      },
      {
        label: "Transaction ",
        width: "80px",
        divClass: "d-flex justify-content-center ",
      },
      {
        label: "Voucher No",
        sortKey: false,
        width: "120px",
        divClass: "d-flex justify-content-center",
      },

      // {
      //   label: "Staff",
      //   width: "80px",
      //   divClass: "d-flex justify-content-center d-none",
      // },
      {
        label: "Voucher description",
        width: "80px",
        divClass: "d-flex justify-content-center ",
      },
      {
        label: "Value ",
        width: "80px",
        // divClass: "d-flex justify-content-end ",
      },

      {
        label: "Percentage",
        sortKey: false,
        width: "100px",
        // divClass: "text-right d-flex justify-content-end ",
      },
      {
        label: "Site Name",
        sortKey: false,
        width: "100px",
        divClass: " text-center d-flex justify-content-center  ",
      },
      {
        label: "Expiry",
        sortKey: false,
        width: "75px",
        divClass: "text-center d-flex justify-content-center ",
      },
      {
        label: "Action",
        sortKey: false,
        width: "50px",
        divClass: "text-center d-flex justify-content-center ",
      },
    ],

    accountList: [],
    accountHeader: {},
    DetailList: [],
    isPrintPdfClick: false,
    oldDetailList: [],
    oldaccountHeader: {},
    isLoading: false,
    show: "active",
  };

  toggle = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  };

  componentDidMount() {
    this.setState({
      isLoading: true,
    });
    this.getAccountData("");
  }

  getAccountData = (api) => {
    this.setState({
      isLoading: true,
    });
    let { accountHeader } = this.state;
    this.props
      .getCommonApi(`voucher/?cust_id=${this.props.id}${api}`)
      .then((key) => {
        let { data, header_data } = key;
        let { accountList } = this.state;
        accountList = data;
        accountHeader = header_data;
        this.setState({ accountList, accountHeader });
      });
    this.setState({
      isLoading: false,
    });
  };

  handleOpenDetail = async (data, tab) => {
    let { activeTab } = this.state;
    activeTab = tab;

    await this.setState({
      activeTab,
    });
  };

  handleBack = () => {
    let { activeTab } = this.state;
    activeTab = "";
    this.setState({
      activeTab,
      DetailList: [],
    });
    this.getAccountData("");
  };
  handlePrintPdfFormat = (url) => {
    this.setState({
      isPrintPdfClick: false,
    });
    var a = document.createElement("a");
    a.setAttribute("download", `${new Date()}.pdf`);
    a.setAttribute("href", url);
    a.click();
    window.open(url);
  };

  handleChange = async (type) => {
    let { show } = this.state;
    show = type;
    await this.setState({
      show,
    });
    if (type === "all") {
      this.getAccountData("&is_all=1");
    } else {
      this.getAccountData("");
    }
  };

  render() {
    let {
      treatmentList,
      headerDetails,
      accountList = [],
      accountHeader = {},
      activeTab,
      detailHeader,
      DetailList,
      isPrintPdfClick,
      oldDetailList,
      olddetailHeader,
      oldaccountHeader,
      isLoading,
      show,
    } = this.state;
    let { t } = this.props;
    return (
      <div className="treatment-account">
        <div className="row mt-3 mb-3">
          <div className="col-md-6">
            <div className="col-12 mb-2">
              <div className="row pt-2">
                <div className="col-12 mb-2 pl-3">
                  {t("Total Voucher Count")} : {accountHeader.tot_count}
                </div>
              </div>
              <FormGroup check>
                <Label check>
                  <Input
                    checked={show === "active"}
                    onChange={() => this.handleChange("active")}
                    type="radio"
                    name="radio1"
                  />{" "}
                  {t("Show Active Vouchers only")}
                </Label>
              </FormGroup>
            </div>
            <div className="col-12">
              <FormGroup check>
                <Label check>
                  <Input
                    checked={show === "all"}
                    onChange={() => this.handleChange("all")}
                    type="radio"
                    name="radio1"
                  />{" "}
                  {t("Show All Vouchers")}
                </Label>
              </FormGroup>
            </div>
          </div>
          <div className="col-md-6">
            <div className="row">
              <div className="col-3 mb-2">{t("Balance of all voucher ")}:</div>
              <div className="col-6 mb-2 ">$ {accountHeader.tot_balance}</div>
              {/* tot_balance */}
            </div>
          </div>
        </div>
        <div className="col-12 mt-2">
          <div className="table">
            {activeTab == "old" ? (
              <TableWrapper
                headerDetails={olddetailHeader}
                queryHandler={this.handlePagination}
                // pageMeta={pageMeta}
                // isEmpty={accountList.length === 0 ? true:false}
              ></TableWrapper>
            ) : activeTab == "detail" ? (
              <TableWrapper
                headerDetails={detailHeader}
                queryHandler={this.handlePagination}
              ></TableWrapper>
            ) : (
              <TableWrapper
                headerDetails={headerDetails}
                queryHandler={this.handlePagination}
                // pageMeta={pageMeta}
                // isEmpty={accountList.length === 0 ? true:false}
              >
                {isLoading ? (
                  <tr>
                    <td colSpan="16">
                      <div class="d-flex mt-5 align-items-center justify-content-center">
                        <div class="spinner-border" role="status">
                          <span class="sr-only">Loading...</span>
                        </div>
                      </div>
                    </td>
                  </tr>
                ) : accountList && accountList.length > 0 ? (
                  accountList.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>
                          <div className="text-center">
                            {item?.sa_date ?? ""}
                          </div>
                        </td>
                        <td>
                          <div className="text-center">{item.transaction}</div>
                        </td>
                        <td>
                          <div className="text-center">{item.voucher_no}</div>
                        </td>

                        {/* <td>
                          <div className="text-center">
                            {item?.issued_staff ?? "--"}
                          </div>
                        </td> */}
                        <td>
                          <div className="text-center">{item.voucher_name}</div>
                        </td>
                        <td>
                          <div className="text-center">{item.value}</div>
                        </td>
                        <td>
                          <div className="text-center">{item.percent}</div>
                        </td>
                        <td>
                          <div className="text-center">
                            {item.sitecode_name}
                          </div>
                        </td>
                        <td>
                          <div className="text-center">
                            {item.issued_expiry_date}
                          </div>
                        </td>
                        <td className="position-relative">
                          <NormalButton
                            buttonClass={"mx-0"}
                            mainbg={true}
                            className=" fs-15 confirm"
                            label="View"
                            outline={false}
                            onClick={() =>
                              history.push(
                                `/admin/transactionhistory/print/bill/${item.sa_transacno}`
                              )
                            }
                          />
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="16">
                      <div class="d-flex  align-items-center justify-content-center fs-18">
                        No data available
                      </div>
                    </td>
                  </tr>
                )}
              </TableWrapper>
            )}
          </div>
        </div>
        <div className="col-12 d-flex justify-center">
          {activeTab === "detail" || activeTab === "old" ? (
            <NormalButton
              buttonClass={"back mr-3"}
              mainbg={true}
              className="col-12 fs-15 "
              label="Back"
              onClick={() => this.handleBack()}
            />
          ) : (
            ""
          )}
        </div>
        {isPrintPdfClick ? (
          <PDFDownloadLink
            document={
              <Invoice
                TableList={activeTab !== "detail" ? accountList : DetailList}
                accountHeader={accountHeader}
                Flag={activeTab !== "detail" ? 5 : 6}
                landscape={activeTab !== "detail" ? true : false}
              />
            }
          >
            {({ blob, url, loading, error }) =>
              !loading && url ? this.handlePrintPdfFormat(url) : null
            }
          </PDFDownloadLink>
        ) : null}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getCommonApi,
      updateForm,
      commonCreateApi,
      commonPatchApi,
      commonDeleteApi,
    },
    dispatch
  );
};

export const VoucherTab = withTranslation()(
  connect(null, mapDispatchToProps)(VoucherTabClass)
);
